<template>
  <div class="map-draw-page">
    <div v-if="loadingPins || loadError" class="map-status" :class="{ error: loadError }">
      {{ loadError || 'Loading map pins...' }}
    </div>
    <div ref="mapDraw" class="map"></div>
  </div>
</template>
<style>
.map-draw-page {
  position: relative;
  padding: 24px 24px 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.map {
  width: 500px;
  height: 500px;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  overflow: hidden;
  border: 2px solid #e2e8f0;
}
.map-status {
  position: absolute;
  top: 36px;
  z-index: 500;
  background: rgba(15, 23, 42, 0.86);
  color: white;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
}
.map-status.error {
  background: rgba(185, 28, 28, 0.92);
}
</style>

<script>
import axios from 'axios';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  components: {},
  data() {
    return {
      mapCenter: { lng: 114.170, lat: 22.319 },
      pins: [],
      loadingPins: false,
      loadError: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.mapDraw;
      const center = [this.mapCenter.lat, this.mapCenter.lng];
      this._map = L.map(el, { zoomControl: true, attributionControl: false }).setView(center, 12);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(this._map);
      this._pinLayer = L.layerGroup().addTo(this._map);
      this.loadPins();
    });
  },
  beforeDestroy() {
    if (this._map) { this._map.remove(); this._map = null; }
  },
  methods: {
    loadPins() {
      this.loadingPins = true;
      this.loadError = '';
      axios.get('/api/location/list')
        .then((response) => {
          this.pins = (response.data && response.data.data) || [];
          this.renderPins();
        })
        .catch((error) => {
          console.error('Failed to load map pins:', error);
          this.loadError = 'Could not load map pins.';
        })
        .finally(() => {
          this.loadingPins = false;
        });
    },
    renderPins() {
      if (!this._pinLayer) return;
      this._pinLayer.clearLayers();
      const bounds = [];
      this.pins.forEach((pin) => {
        const lat = Number(pin.lat);
        const lon = Number(pin.lon);
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
        const marker = L.marker([lat, lon]);
        marker.bindPopup(this.popupHtml(pin));
        marker.addTo(this._pinLayer);
        bounds.push([lat, lon]);
      });
      if (bounds.length > 0) {
        this._map.fitBounds(L.latLngBounds(bounds), { padding: [40, 40], maxZoom: 15 });
      }
    },
    popupHtml(pin) {
      const title = this.escapeHtml(pin.houseName || 'Housing location');
      const room = this.escapeHtml(pin.houseLetName || '');
      const place = [pin.area, pin.district].filter(Boolean).map(this.escapeHtml).join(' · ');
      const roomLine = room ? `<br>${room}` : '';
      const placeLine = place ? `<br><span>${place}</span>` : '';
      return `<strong>${title}</strong>${roomLine}${placeLine}`;
    },
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }
};
</script>
